/* Squish Club theme JS — vanilla, no dependencies.
   Talks to Shopify's AJAX Cart API. The static preview swaps in a mock (preview/mock-cart.js). */
(() => {
  const SC = window.SC || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const money = c => 'R' + (c / 100).toLocaleString('en-ZA', {minimumFractionDigits: c % 100 ? 2 : 0, maximumFractionDigits: 2}).replace(/\u00a0/g, ' ');
  const esc = s => String(s ?? '').replace(/[&<>"']/g, m => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m]));
  const json = (url, body) => fetch(url, body ? {method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'}, body:JSON.stringify(body)} : {headers:{Accept:'application/json'}}).then(r => { if (!r.ok) throw r; return r.json(); });
  const routes = Object.assign({cart:'/cart.js', add:'/cart/add.js', change:'/cart/change.js', update:'/cart/update.js'}, SC.routes || {});

  /* ---------- toast ---------- */
  let toastT; function toast(msg){ let t=$('.toast'); if(!t){t=document.createElement('div');t.className='toast';t.setAttribute('role','status');document.body.append(t);} t.textContent=msg; t.classList.add('is-on'); clearTimeout(toastT); toastT=setTimeout(()=>t.classList.remove('is-on'),2200); }

  /* ---------- Estimated delivery (business days, SA public holidays, cut-off) ---------- */
  function addBusinessDays(start, n, holidays){
    const d = new Date(start); let added = 0;
    while (added < n){ d.setDate(d.getDate()+1); const iso = d.toISOString().slice(0,10); const wd = d.getDay(); if (wd!==0 && wd!==6 && !holidays.includes(iso)) added++; }
    return d;
  }
  function eta(){
    const el = $$('[data-eta]'); if (!el.length) return;
    const cfg = SC.delivery || {}; const hol = cfg.holidays || [];
    const now = SC.now ? new Date(SC.now) : new Date();
    // Use SAST regardless of the shopper's device zone
    const sast = new Date(now.toLocaleString('en-US',{timeZone:'Africa/Johannesburg'}));
    let ship = new Date(sast); ship.setHours(12,0,0,0);
    const iso = ship.toISOString().slice(0,10);
    const isBiz = ship.getDay()!==0 && ship.getDay()!==6 && !hol.includes(iso);
    const extra = (!isBiz || sast.getHours() >= (cfg.cutoff ?? 13)) ? 1 : 0;
    const dispatch = extra ? addBusinessDays(ship, 1, hol) : ship;
    // v3.4: peak season padding (e.g. 15 Nov - 10 Jan, wraps over New Year)
    const md = d => (d.getMonth()+1)*100 + d.getDate();
    const parseMD = s => { const m = /^(\d{1,2})-(\d{1,2})$/.exec(String(s||'').trim()); return m ? (+m[1])*100 + (+m[2]) : null; };
    const ps = parseMD(cfg.peakStart), pe = parseMD(cfg.peakEnd), cur = md(dispatch);
    const inPeak = ps != null && pe != null && (ps <= pe ? (cur >= ps && cur <= pe) : (cur >= ps || cur <= pe));
    const pad = inPeak ? (+cfg.peakExtra || 0) : 0;
    const from = addBusinessDays(dispatch, (cfg.min ?? 2) + pad, hol), to = addBusinessDays(dispatch, (cfg.max ?? 4) + pad, hol);
    const f = d => d.toLocaleDateString('en-ZA',{weekday:'short', day:'numeric', month:'short'});
    el.forEach(e => { $('[data-eta-range]', e).textContent = `${f(from)} – ${f(to)}`; });
  }

  /* ---------- v3.4: Christmas cut-off (SAST date check) ---------- */
  function xmas(){
    const els = $$('[data-xmas]'); if (!els.length) return;
    const now = SC.now ? new Date(SC.now) : new Date();
    const todaySast = now.toLocaleDateString('en-CA', {timeZone:'Africa/Johannesburg'}); // YYYY-MM-DD
    els.forEach(el => {
      const d = (el.dataset.date || '').trim(); const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(d);
      const txt = $('[data-xmas-text]', el);
      if (!m) return; // free-text date: keep the server-rendered "before" line
      const nice = new Date(Date.UTC(+m[1], +m[2]-1, +m[3], 12)).toLocaleDateString('en-ZA', {weekday:'short', day:'numeric', month:'short', timeZone:'UTC'});
      if (todaySast <= d){ txt.textContent = (el.dataset.before || 'Order by {date} for Christmas delivery').replace('{date}', nice); }
      else if (el.dataset.after){ txt.innerHTML = `<a href="${esc(el.dataset.link || '/products/digital-gift-card')}">${esc(el.dataset.after)}</a>`; el.classList.add('is-after'); }
      else { el.hidden = true; }
    });
  }

  /* ---------- Tier selector + box picker + add to cart ---------- */
  function initProduct(form){
    const tiers = $$('input[name="tier"]', form);
    const sticky = $('.sticky-atc'); const stickyPrice = sticky && $('[data-sticky-price]', sticky);
    const atcLabel = $$('[data-atc-label]');
    const picker = $('[data-picker]', form);
    const picks = picker ? $$('input[type="checkbox"]', picker) : [];
    const need = picker ? +picker.dataset.need || 5 : 0;
    let order = picks.filter(c => c.checked);            // keep the order they were picked in
    const current = () => tiers.find(i => i.checked) || tiers[0];
    const pickerOn = () => !!picker && (picker.hasAttribute('data-always') || current()?.value === picker.dataset.tier);
    const err = msg => { const e = picker && $('[data-pick-err]', picker); if (e) e.textContent = msg || ''; };
    const syncPicker = () => {
      if (!picker) return;
      const on = pickerOn();
      picker.hidden = !on;
      order = order.filter(c => c.checked);
      const full = order.length >= need;
      picks.forEach(c => { c.disabled = !on || (full && !c.checked); c.closest('.pick')?.classList.toggle('is-on', c.checked); });
      const n = $('[data-pick-count]', picker); if (n) n.textContent = `${order.length}/${need}`;
      picker.classList.toggle('is-full', full);
      if (full) err(''); 
    };
    const missing = () => pickerOn() ? Math.max(0, need - order.length) : 0;
    const sync = () => {
      const t = current(); if (!t) return;
      tiers.forEach(i => i.closest('.tier')?.classList.toggle('is-active', i.checked));
      // v3.4: honest saving on the button (3-pack = real R saving vs 3 singles + free shipping, box = real R saving vs 5 singles)
      const label = t.dataset.atcText || `${SC.strings?.add || 'Add to cart'} · ${money(+t.dataset.price)}`;
      // v3.6: glowing save pill. Build the label from text nodes + one span, no innerHTML.
      const clean = String(label).replace(/R\s+(?=\d)/g, 'R');
      atcLabel.forEach(l => {
        l.textContent = '';
        clean.split(' · ').forEach((part, i) => {
          if (i) l.append(' · ');
          if (/^(Save\b|Free shipping$)/.test(part)) { const s = document.createElement('span'); s.className = 'sc-save'; s.textContent = part; l.append(s); }
          else l.append(part);
        });
      });
      if (stickyPrice) stickyPrice.textContent = (t.dataset.summary || '').replace(/R\s+(?=\d)/g, 'R');
      const sl = $('[data-ship-line]', form);
      if (sl){ const th = +sl.dataset.th, single = +sl.dataset.singleShip, price = +t.dataset.price;
        if (price >= th) { sl.textContent = '✓ ' + (SC.strings?.freeOrder || 'Free shipping on this order'); sl.classList.remove('is-nudge'); }
        else { sl.textContent = '👉 ' + (SC.strings?.addOne || 'Add 1 more for free shipping') + (single ? ' · ' + (SC.strings?.singleShip || '').replace('{amount}', money(single)) : ''); sl.classList.add('is-nudge'); }
      }
      syncPicker();
    };
    const submit = async e => {
      e?.preventDefault();
      const t = current(); if (!t) return;
      const left = missing();
      if (left){
        err(left === 1 ? (SC.strings?.pickMoreOne || 'Pick 1 more to fill your box') : (SC.strings?.pickMore || 'Pick %n more to fill your box').replace('%n', left));
        picker.scrollIntoView({behavior:'smooth', block:'center'});
        picker.classList.remove('is-shake'); void picker.offsetWidth; picker.classList.add('is-shake');
        return;
      }
      const btns = $$('[data-atc]'); btns.forEach(b => b.disabled = true);
      const note = $('[name="properties[Gift message]"]', form)?.value.trim();
      const item = {id:+t.dataset.variant, quantity:+t.dataset.qty || 1, properties:{}};
      if (pickerOn()) order.forEach((c, i) => item.properties[`Squishy ${i + 1}`] = c.value);
      if (note) item.properties['Gift message'] = note;
      if (t.dataset.tierName) item.properties['_tier'] = t.dataset.tierName;
      // v3.4 gift card: send straight to the recipient when an email is filled in
      const rec = $('[data-gc-recipient]', form);
      if (rec){ const em = $('[name="properties[Recipient email]"]', rec)?.value.trim();
        if (em){ $$('[name^="properties["]', rec).forEach(f => { const k = f.name.slice(11, -1); if (f.value.trim()) item.properties[k] = f.value.trim(); }); } }
      const items = [item];
      // v3.5 free mini: the Full Club tier also adds the chosen mini; the automatic discount makes it R0
      if (t.dataset.freeMini) items.push({id:+t.dataset.freeMini, quantity:1, properties:{'_free_mini':'1'}});
      try { await json(routes.add, {items}); await Cart.refresh(); Cart.open(); }
      catch(err){ toast(SC.strings?.error || 'Could not add that. Please try again.'); }
      finally { btns.forEach(b => b.disabled = false); }
    };
    // bind the submit handler first, so nothing below can stop the drawer from opening
    form.addEventListener('submit', submit);
    $('[data-sticky-atc]')?.addEventListener('click', submit);
    tiers.forEach(i => i.addEventListener('change', sync));
    picks.forEach(c => c.addEventListener('change', () => {
      if (c.checked) { if (order.length >= need) { c.checked = false; err(SC.strings?.pickFull || ''); return; } order.push(c); }
      syncPicker();
    }));
    try { sync(); } catch(e){ console.warn('[squish] tier sync', e); }
    // show sticky bar once the main button scrolls out of view
    const main = $('[data-atc]', form);
    if (sticky && main && 'IntersectionObserver' in window){
      new IntersectionObserver(([en]) => sticky.classList.toggle('is-visible', !en.isIntersecting)).observe(main);
    }
    initGallery($('[data-gallery]'));
  }

  /* ---------- Swipeable gallery (native scroll-snap; JS only syncs dots) ---------- */
  function initGallery(g){
    if (!g) return; const track = $('.gallery__track', g); const btns = $$('[data-go]', g);
    if (!track || !btns.length) return;
    let raf; track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(() => {
      const i = Math.round(track.scrollLeft / track.clientWidth); btns.forEach(b => b.setAttribute('aria-current', +b.dataset.go === i)); }); }, {passive:true});
    btns.forEach(b => b.addEventListener('click', () => track.scrollTo({left: +b.dataset.go * track.clientWidth, behavior:'smooth'})));
  }

  /* ---------- Trust marquee: tap to pause/resume (hover + focus pause in CSS) ---------- */
  function marquee(){
    $$('[data-marquee]').forEach(m => m.addEventListener('click', () => m.classList.toggle('is-paused')));
  }

  /* ---------- Cart drawer ---------- */
  const Cart = {
    el: null, cart: null,
    open(){ if (!this.el) return; const was = this.el.classList.contains('is-open'); this.el.classList.add('is-open'); document.body.classList.add('no-scroll'); $('.x-btn', this.el)?.focus();
      if (!was){ this.sliding = true; clearTimeout(this._st); this._st = setTimeout(() => { this.sliding = false; const p = this.pendingBar; this.pendingBar = null; if (p) this.paintBar(...p); }, 380); } },
    paintBar(bar, pct){
      const prev = +bar.dataset.p || 0;
        $('.ship-bar__fill', bar).style.width = pct + '%'; bar.style.setProperty('--p', pct);
      if (pct !== prev && bar.dataset.p !== undefined){ bar.classList.remove('is-hop','is-party'); void bar.offsetWidth; bar.classList.add(pct >= 100 && prev < 100 ? 'is-party' : 'is-hop'); }
      bar.dataset.p = pct;
      // roll like a wheel: rotation = distance travelled / circumference
      const rail = $('.ship-bar__rail', bar), rider = $('.ship-bar__rider', bar);
      if (rail && rider){ const d = rider.offsetWidth || 34, travel = (rail.clientWidth - 2 * (parseFloat(getComputedStyle(rail).paddingLeft) || 20)) * pct / 100;
        bar.style.setProperty('--rot', (travel / (Math.PI * d) * 360).toFixed(1) + 'deg'); }
    },
    close(){ this.el?.classList.remove('is-open'); document.body.classList.remove('no-scroll'); },
    async refresh(){ this.cart = await json(routes.cart); this.render(); return this.cart; },
    protectId(){ return +SC.protection?.variant || 0; },
    render(){
      const c = this.cart; if (!c || !this.el) return;
      const pid = this.protectId();
      const items = c.items.filter(i => i.variant_id !== pid);
      const protectedOn = c.items.some(i => i.variant_id === pid);
      const merchSubtotal = items.filter(i => !i.gift_card).reduce((s,i)=>s+i.final_line_price,0);
      const th = +SC.freeShipping || 0;
      $$('.cart-btn__count').forEach(e => { const n = items.reduce((s,i)=>s+i.quantity,0); if (e.dataset.count !== String(n)) { e.classList.remove('bump'); void e.offsetWidth; e.classList.add('bump'); } e.textContent = n || ''; e.dataset.count = n; });
      // free-shipping bar, based on products only (protection doesn't count)
      const bar = $('.ship-bar', this.el);
      if (bar && th){
        const left = Math.max(0, th - merchSubtotal);
        bar.classList.toggle('is-done', !left);
        $('.ship-bar__msg', bar).innerHTML = !items.length ? esc(SC.strings?.shipStart || '').replace('{amount}', `<strong>${money(th)}</strong>`)
          : left ? (SC.strings?.shipLeft || 'You\'re {amount} away from free shipping').replace('{amount}', `<strong>${money(left)}</strong>`)
          : (SC.strings?.shipDone || '🎉 You\'ve unlocked free shipping!');
        const pct = Math.min(100, merchSubtotal / th * 100);
        // v3.5: only roll while the drawer is visible. Rendering happens before open(), so on mobile the roll used to finish behind the full-width sliding panel.
        if (this.el.classList.contains('is-open') && !this.sliding) this.paintBar(bar, pct); else { this.pendingBar = [bar, pct]; if (bar.dataset.p === undefined) bar.dataset.p = 0; }
      }
      const body = $('.drawer__body', this.el);
      if (!items.length){
        body.innerHTML = `<div class="cart-empty">${SC.emptyImg ? `<img src="${SC.emptyImg}" alt="">` : ''}<h3>${esc(SC.strings?.empty || 'Your cart is empty')}</h3><p class="muted">${esc(SC.strings?.emptySub || '')}</p><a class="btn" href="${SC.routes?.all || '/collections/all'}">${esc(SC.strings?.shop || 'Shop squishies')}</a></div>`;
        $('.drawer__foot', this.el).hidden = true;
        if (protectedOn) this.change(pid, 0);
        return;
      }
      $('.drawer__foot', this.el).hidden = false;
      body.innerHTML = items.map(i => {
        const gift = i.properties && i.properties['Gift message'];
        const picked = Object.entries(i.properties || {}).filter(([k,v]) => /^(Squishy|Pick) \d+$/.test(k) && v).map(([,v]) => v);
        return `<div class="line" data-key="${esc(i.key)}">
          <img src="${esc(i.image || SC.emptyImg || '')}" alt="" width="76" height="76" loading="lazy">
          <div><div class="line__title">${esc(i.product_title)}</div>
          ${picked.length ? `<div class="line__meta">💜 ${esc(picked.join(', '))}</div>` : ''}
          ${gift ? `<div class="line__meta">🎁 Gift message: “${esc(gift)}”</div>` : ''}
          ${i.properties && i.properties._free_mini ? `<div class="line__meta line__meta--free">Free mini with your Full Club</div>` : ''}
          ${i.gift_card ? `<div class="line__meta">Emailed instantly</div>` : ''}
          <div class="qty"><button type="button" data-qty="${i.quantity-1}" aria-label="Decrease">−</button><span>${i.quantity}</span><button type="button" data-qty="${i.quantity+1}" aria-label="Increase">+</button></div>
          <div class="line__acts"><button type="button" class="link-btn" data-qty="0">Remove</button>${i.quantity === 1 && !i.gift_card && !(i.properties && i.properties._free_mini) && !(SC.noMakeTwo || []).includes(i.variant_id) && merchSubtotal < th && merchSubtotal + i.final_line_price >= th ? `<button type="button" class="mini-btn" data-qty="2">${esc(SC.strings?.makeTwo || 'Make it 2')}</button>` : ''}</div></div>
          <div class="line__price">${money(i.final_line_price)}</div></div>`; }).join('') + this.stocking(items) + this.upsells(items);
      // protection toggle (not for gift-card-only carts)
      const physical = items.some(i => !i.gift_card);
      const p = $('[data-protect]', this.el);
      if (p){ p.hidden = !pid || !physical; const cb = $('input', p); cb.checked = protectedOn; }
      if (protectedOn && !physical) this.change(pid, 0);
      const total = c.total_price;
      $('[data-cart-total]', this.el).textContent = money(total);
    },
    stocking(items){
      const fm = SC.freeMini; if (!fm || !fm.stocking || !items.some(i => !i.gift_card)) return '';
      if (items.some(i => i.variant_id === +fm.variant && !(i.properties && i.properties._free_mini))) return '';
      return `<div class="stocking">${fm.image ? `<img src="${esc(fm.image)}" alt="" loading="lazy">` : ''}<b>${esc(fm.stockingText || 'Add a mini for their stocking')}<br><small class="muted">${esc(fm.title)} · ${money(fm.price)}</small></b><button type="button" class="mini-btn" data-add="${fm.variant}">+ Add</button></div>`;
    },
    upsells(items){
      // gap-aware: when short of free shipping, show first the cheapest item that closes the gap
      const sub = items.reduce((s,i)=>s+i.final_line_price,0), gap = Math.max(0, (+SC.freeShipping || 0) - sub);
      let list = (SC.upsells || []).filter(u => !items.some(i => i.variant_id === +u.variant));
      if (gap) list = list.sort((a,b) => ((a.price >= gap ? 0 : 1) - (b.price >= gap ? 0 : 1)) || a.price - b.price);
      list = list.slice(0,2);
      if (!list.length) return '';
      return `<div class="cart-up"><h3>${esc(SC.strings?.upsell || 'Add a squish buddy')}</h3>${list.map(u => `
        <div class="upsell__item"><img src="${esc(u.image)}" alt="" loading="lazy"><div><b>${esc(u.title)}</b><div class="muted" style="font-size:.85rem;font-weight:800">${money(u.price)}</div></div>
        <button type="button" class="mini-btn" data-add="${u.variant}">+ Add</button></div>`).join('')}</div>`;
    },
    async change(id, quantity){ this.cart = await json(routes.change, typeof id === 'string' ? {id, quantity} : {id:String(id), quantity}); this.render(); },
    init(){
      this.el = $('#CartDrawer'); if (!this.el) return;
      $$('[data-cart-open]').forEach(b => b.addEventListener('click', e => { e.preventDefault(); this.open(); }));
      $$('[data-cart-close]', this.el).forEach(b => b.addEventListener('click', () => this.close()));
      document.addEventListener('keydown', e => e.key === 'Escape' && this.close());
      this.el.addEventListener('click', async e => {
        const q = e.target.closest('[data-qty]'); const a = e.target.closest('[data-add]');
        if (q){ const key = q.closest('.line').dataset.key; await this.change(key, +q.dataset.qty); }
        if (a){ a.disabled = true; await json(routes.add, {items:[{id:+a.dataset.add, quantity:1}]}); await this.refresh(); toast('Added 💜'); }
      });
      $('[data-protect] input', this.el)?.addEventListener('change', async e => {
        const pid = this.protectId();
        if (e.target.checked) { await json(routes.add, {items:[{id:pid, quantity:1}]}); await this.refresh(); }
        else { const line = this.cart.items.find(i => i.variant_id === pid); if (line) await this.change(line.key, 0); }
      });
      $('[data-gift-flag] input', this.el)?.addEventListener('change', e => json(routes.update || '/cart/update.js', {attributes:{Gift: e.target.checked ? 'Yes' : ''}}).catch(()=>{}));
      $$('[data-quick-add]').forEach(b => b.addEventListener('click', async e => { e.preventDefault(); b.disabled = true;
        try { await json(routes.add, {items:[{id:+b.dataset.quickAdd, quantity:1}]}); await this.refresh(); this.open(); } finally { b.disabled = false; } }));
      this.refresh().catch(()=>{});
      if (SC.openCart) this.open();
    }
  };
  window.SquishCart = Cart;

  document.addEventListener('DOMContentLoaded', () => {
    const safe = (name, fn) => { try { fn(); } catch(e){ console.warn('[squish] ' + name, e); } };
    safe('cart', () => Cart.init()); safe('eta', eta); safe('xmas', xmas); safe('marquee', marquee);
    $$('form[data-product-form]').forEach(f => safe('product', () => initProduct(f)));
    // squish the hero characters on tap
    document.addEventListener('pointerdown', e => { const t = e.target.closest('.hero__char,.card__img img,.gallery__slide img,.who__card img,.gift__chars img'); if (!t) return; t.classList.remove('is-squish'); void t.offsetWidth; t.classList.add('is-squish'); });
  });
})();

/* v3.7: Tap me badge + squash on tap (mobile only). Uses click so swipes and pinch-zoom never trigger it. */
(function(){
  var mq = window.matchMedia('(max-width:749px)');
  function init(){
    var g = document.querySelector('[data-gallery]'); if (!g || g.querySelector('.sc-tapme')) return;
    var b = document.createElement('span'); b.className = 'sc-tapme'; b.setAttribute('aria-hidden','true'); b.textContent = 'Tap me'; g.appendChild(b);
    g.addEventListener('click', function(e){
      if (!mq.matches) return;
      var img = e.target.closest('.gallery__slide img'); if (!img) return;
      b.classList.add('is-gone');
      img.classList.remove('is-squish','sc-squash'); void img.offsetWidth; img.classList.add('sc-squash');
      img.addEventListener('animationend', function f(){ img.classList.remove('sc-squash'); img.removeEventListener('animationend', f); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
